function addReload() {
  const a = document.createElement("a");
  const text = document.createTextNode("刷新");
  a.setAttribute("href", "javascript:location.reload();");
  a.appendChild(text);
  a.style.position = "fixed";
  a.style.top = "0";
  a.style.background = "red";
  a.style.padding = "5px";
  a.style.zIndex = "99";
  document.body.appendChild(a);
}

if (process.env.NODE_ENV === "development") {
  /* eslint-disable-next-line @typescript-eslint/no-var-requires */
  const Vconsole = require("vconsole");
  new Vconsole();
  addReload();
}

// const Vconsole = require("vconsole");
// new Vconsole();
// addReload();

(function () {
  const ALT_CODE = 18;
  const D_CODE = 68;
  // const F12_CODE = 123;
  let ctrl = false;
  window.addEventListener("keydown", function (e) {
    if (e.keyCode === ALT_CODE) {
      ctrl = true;
    } else if (e.keyCode === D_CODE && ctrl) {
      window.registrations && window.registrations.unregister();
      window.registrations = null;
    }
  });

  window.addEventListener("keyup", function (e) {
    if (e.keyCode === ALT_CODE) {
      ctrl = false;
    }
  });
})();
